import { gql } from "@apollo/client";

export const GetProduct = gql`
  query GetProduct($id: String!) {
    productOne(id: $id) {
      name
      cost
      description
      isActive
      isCommissionable
      isCommissionPercent
      commissionValue
      isTaxable
      isPostTax
      stock
      imgUrl
      metricValues {
        id
        name
        metric {
          name
          id
        }
      }
      tags {
        id
        name
      }
      revenue {
        id
        name
      }
      barcode
      sku
      taxRates {
        id
        organizationTaxRate {
          name
        }
      }
    }
  }
`;

export const ProductPage = gql`
  query ProductPage($pagination: PaginationInput!) {
    productPage(pagination: $pagination) {
      items {
        id
        name
        cost
        sku
        barcode
        description
        location {
          id
          name
        }
        imgUrl
      }
      totalRows
    }
  }
`;

// Product Group
export const GetProductGroup = gql`
  query GetProductGroup($productGroupOneId: String!) {
    productGroupOne(id: $productGroupOneId) {
      name
      description
      imgUrl
      location {
        id
      }
      revenueCategory {
        id
        name
      }
      products {
        id
        name
        stock
        imgUrl
        metricValues {
          id
        }
      }
      metrics {
        id
        name
        values {
          id
          name
        }
      }
    }
  }
`;

export const GetProductGroupPage = gql`
  query GetProductGroupPage(
    $pagination: PaginationInput!
    $locationId: String
  ) {
    productGroupPage(pagination: $pagination, locationId: $locationId) {
      items {
        id
        name
        description
        imgUrl
        createdDate
      }
      totalRows
    }
  }
`;

export const GetProductGroupPageDetail = gql`
  query GetProductGroupPageDetail(
    $pagination: PaginationInput!
    $locationId: String
    $getByProductsCount: Boolean
    $includeVirtual: Boolean
  ) {
    productGroupPage(
      pagination: $pagination
      locationId: $locationId
      getByProductsCount: $getByProductsCount
      includeVirtual: $includeVirtual
    ) {
      items {
        id
        name
        description
        imgUrl
        createdDate
        products {
          id
          name
          cost
          stock
          imgUrl
          description
          taxRates {
            organizationTaxRate {
              name
            }
            taxRate
          }
          isTaxable
          isPostTax
          productGroup {
            id
          }
          metricValues {
            id
          }
          isActive
        }
        metrics {
          id
          name
          values {
            id
            name
          }
        }
      }
      totalRows
    }
  }
`;
